export default{
    data(){
        return{
            sLoginName:'',
            sCustomerName:'',
            listLoading:false,
            Logins:[],
            pageIndex:1,
            pageSize:15,
            recordtotal:0,
            editForm:[],
            customers:[],
            roles:[],
            editFormVisible:false,
            formLabelWidth: '90px',
            currentRowIndex:-1,
        }
    },
    methods: {
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = 'Login/getlist';

            this.$axios.get(getMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'LoginName':me.sLoginName,
                        'CustomerName':me.sCustomerName,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        debugger
                        me.Logins = response.data.Data.DataSource;
                        me.recordtotal = response.data.Data.TotalRecords;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });

            this.listLoading = false;
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        handleAdd(){
            this.bIsNew = true;
            this.currentRowIndex = -1;
            this.editFormVisible = true;
            this.editForm = Object.assign({}, {
                    'Id': 0,
                    'LoginName': '',
                    'Password': '',
                    'bSuspend':false,
                    'Wechat':''
            }); //这句是关键！！！
        },
        handleRefresh()
        {
            this.listLoading = true;
            this.LoadData();
        },
        handleEdit(index, row) {
            this.bIsNew = false;
            this.currentRowIndex = index;
            this.editFormVisible = true;
            
            this.editForm = Object.assign({}, row); //这句是关键！！！
          },
        //点击关闭dialog
        handleClose(done) {
            /*done();
            location.reload();*/
            this.editFormVisible = false;
        },  
        //点击取消
        handleCancel() {
            this.editFormVisible = false;
        },
        //点击更新
        handleUpdate() { 
            
            var me = this;
            this.editFormVisible = false;

            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            //Save Customer
            var getMethod = 'Login/save';

            var bSuspend = "N";
            if(me.editForm.bSuspend)
            {
                bSuspend = "Y";
            }
            
             this.$axios.post(getMethod,
                {
                    'CurrentTokenId': user.TokenId,
                    'CurrentUser': user.LoginName,  
                    'Id': me.editForm.Id,
                    'LoginName': me.editForm.LoginName,
                    'Password': me.editForm.Password,
                    'Suspend': bSuspend,
                    'CustomerId': me.editForm.CustomerId,
                    'RoleId': me.editForm.RoleId,
                    'Wechat': me.editForm.Wechat,
                })
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        this.$message("保存成功.")
                        this.LoadData();
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                
                }
            })
            .catch(function (error) {
                this.alert(error);
            }); 
        },
        handleDelete(index, row) {
            this.$confirm('此操作将永久删除该帐户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                    var user = sessionStorage.getItem('user');
                    if (user) {
                        user = JSON.parse(user);
                    }

                    var Method = 'Login/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                               this.LoadData();
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.alert(strMsg);
                            }
                    })
                    .catch(function (error) {
                        this.alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
          },
          getcustomers(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "common/getcustomerlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.customers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        getroles(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "Login/getroles/"+user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.roles = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
    },
    mounted () {
        var me = this;
        this.LoadData();
        this.getcustomers();
        this.getroles();
    },
}


// WEBPACK FOOTER //
// ./src/components/MaintainLogin/MaintainLogin.js